import { Checkbox } from "@trussworks/react-uswds";

type FilterCheckboxProps = {
  name: string;
  value: string;
  label: string;
  selectedFilterValues: string[];
  customChecked?: () => boolean;
  onChange: () => void;
};

function FilterCheckbox({
  name,
  value,
  label,
  selectedFilterValues,
  customChecked,
  onChange,
}: FilterCheckboxProps) {
  return (
    <Checkbox
      id={value}
      name={name}
      label={label}
      checked={customChecked ? customChecked() : selectedFilterValues.includes(value)}
      onChange={onChange}
      value={value}
    />
  );
}

export default FilterCheckbox;
